import { UNKNOWN_ERROR } from '@/gf/providers/MsgsProvider'
import { ApolloError } from '@apollo/client'

export type OnErrorCallback = (message: string, needsReload: boolean) => void

// Errors that indicate stale page state — prompt the user to reload
const RELOAD_ERRORS = [
  'This request has already been quoted by someone on your team.',
  'This request has been closed and can no longer be quoted.',
  // Legacy atom values (pre-human-readable messages)
  'request_already_quoted_by_store',
  'request_closed',
]

const handleError = (err: unknown, callback: OnErrorCallback) => {
  const apolloErr = err as ApolloError
  const message = apolloErr?.graphQLErrors?.[0]?.message

  if (!message) {
    callback(UNKNOWN_ERROR, false)
    return
  }

  const needsReload = RELOAD_ERRORS.includes(message)
  callback(message, needsReload)
}

export { handleError }
